import AppContext from "PFApp/app_context";
import { useGrowl } from "PFApp/use_growl";
import { Button } from "PFComponents/button";
import ConfirmModal from "PFComponents/confirm/confirm_modal";
import { getProfileName } from "PFCore/helpers/profile";
import { deleteUser } from "PFCore/services/admin/users/delete_user";
import PropTypes from "prop-types";
import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

const RemoveAction = ({ user, refetchUsers }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.list.actions" });

  const growl = useGrowl();

  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const [showModal, setShowModal] = useState(false);

  const handleRemoveUser = useCallback(() => {
    deleteUser(user.id)
      .then((resp) => {
        refetchUsers();
        growl({ message: resp.message });
      })
      .catch((jqXHR) => growl({ message: jqXHR.responseJSON.message, kind: "error" }));
  }, [user]);

  if (currentProfile.id === user.id) {
    return false;
  }

  return (
    <>
      <Button
        text={t("remove")}
        small
        kind={"danger"}
        onClick={() => setShowModal(true)}
        qaId="AdminActionButton.remove"
      />
      {showModal && (
        <ConfirmModal handleOK={handleRemoveUser} handleClose={() => setShowModal(false)}>
          {t("removeConfirm", { name: getProfileName(user) })}
        </ConfirmModal>
      )}
    </>
  );
};

RemoveAction.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    roles: PropTypes.array
  }),

  refetchUsers: PropTypes.func
};

export default RemoveAction;
